import { render, staticRenderFns } from "./Nebiki.vue?vue&type=template&id=d29f5e88&"
import script from "./Nebiki.vue?vue&type=script&lang=js&"
export * from "./Nebiki.vue?vue&type=script&lang=js&"
import style0 from "./Nebiki.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports